import React, { Fragment, useEffect, useState } from "react";
import { Button, Col, Container, Form, Modal, Row, Table } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Navbar from "../../Components/Navbar/Navbar";
import trash from "./../../Assets/Images/trash.png";
import Select from "react-select";
import { Select as SearchBox } from 'antd';
import "./Inventory.css";
import { antdesignSelectStyle, getTodayDateISOFormat, getType, numberFormat, toastStyle } from "../../Helpers/Utils/Common";
import {
  getTransfer,
  getTransferReceive,
  createTransferReceive,
  updateTransferReceive,
  updateTransferReceiveStatus,
} from "../../Helpers/apiCalls/Inventory/TransferApi";
import { getAllItemList } from "../../Helpers/apiCalls/Inventory/ItemListApi";
import { getAllEmployees } from "../../Helpers/apiCalls/employeesApi";
import { validateTransferReceive } from "../../Helpers/Validation/Inventory/TransferValidation";
import InputError from "../../Components/InputError/InputError";
import toast from "react-hot-toast";
import Moment from "moment";
import ReactLoading from "react-loading";
import TransferModal from "./Transfer/TransferModal";
import Upload from "antd/es/upload/Upload";
import upload from "../../Assets/Images/upload.png";
import Footer from "../../Components/Footer/Footer";
/**
 *  COMPONENT: FORM TO ADD OR EDIT PAYMENT
 */
function FormReceiveTransfer({ add, edit, request }) {
  let navigate = useNavigate();
  const { Dragger } = Upload;
  const { state } = useLocation();
  const { id, type } = useParams();
  const [inactive, setInactive] = useState(true);
  const [showLoader, setShowLoader] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [itemOptions, setItemOptions] = useState([]);

  // DATA HANDLERS
  const [entries, setEntries] = useState([]);
  const [filteredEntries, setFilteredEntries] = useState([]);
  const [receiveItems, setReceiveItems] = useState([]);
  const [items, setItems] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [fileSizeExceeded, setFileSizeExceeded] = useState(false);
  const [file, setFile] = useState("");
  const [previewFile, setPreviewFile] = useState(null);
  const [preview, setPreview] = useState(false);

  const [newTransfer, setNewTransfer] = useState({
    transfer_date: "",
    transfer_receive_date: "",
    transfer_number: "",
    branch_from: "",
    branch_to: "",
    remarks: "",
    dispatcher: "0",
    received_by: "",
  });
  const userType = getType();

  const [employeeValue, setEmployeeValue] = useState({
    name: "received_by",
    label: "",
    value: "",
  });

  /* Approve Modal */
  const [showApproveModal, setShowApproveModal] = useState(false);
  const handleShowApproveModal = () => setShowApproveModal(true);
  const handleCloseApproveModal = () => setShowApproveModal(false);

  //ERROR HANDLING
  const [isError, setIsError] = useState({
    transfer_receive_date: false,
    received_by: false,
  });

  // SELECT DROPSEARCH CHANGE HANDLER
  function handleSelectChange(e) {
    const newList = newTransfer;
    newList[e.name] = e.value;
    setNewTransfer(newList);
    if (e.name === "received_by") {
      setEmployeeValue({ name: e.name, label: e.label, value: e.value });
    }
  }

  // PAYMENT DETAILS CHANGE HANDLER
  function handlePayChange(e) {
    const { name, value } = e.target;
    const newList = newTransfer;
    newList[name] = value;
    setNewTransfer(newList);
  }

  // ADD ANOTHER INVOICE HANDLER
  function AddItem() {
    const newItem = {
      entry: {
        name: "item_id",
        label: "",
        value: "",
      },
      prices: 0,
      id: 0,
      units: "",
      quantities: "",
    };
    setItems((prevItems) => [...prevItems, newItem]);
  }

  // INVOICE CHANGE HANDLER
  function handleItemChange(e, id, table, type) {
    if (table === "additional") {
      if (type === "item_id") {
        var temp = items;
        var item_name = itemOptions.filter((data) => {
            return data.value === e
        })
        temp[id].is_old_item = false;
        temp[id].item_id = item_name[0].value;
        temp[id].label = item_name[0].label;
        temp[id].value = item_name[0].value;
        temp[id].item_id_value = { label: item_name[0].label, value: item_name[0].value };
        temp[id].item_units = item_name[0].item_units;
        temp[id].units = item_name[0].item_units[0]?.unit_from;
        temp[id].item_unit_id = item_name[0].item_units[0]?.id;
        temp[id].unit_value = item_name[0].item_units[0]?.unit_from + "|" + item_name[0].item_units[0]?.id;
        setItems(temp);

        // var newItemList = items;
        // var newEntries = newItemList.map((item, index) => {
        //   if (index === id) {
        //     var info = {
        //       name: name,
        //       label: label,
        //       value: value,
        //     };
        //     item.entry = info;
        //     item.value = value
        //     item.prices = prices;
        //     item.units = unit;
        //     item.item_unit_id = item_unit_id;
        //     item.current_qty = current_qty;
        //   }
        //   return item;
        // });
        // setItems(newEntries);

        // const filteredOptions = entries.filter(option => {
        //   return !newEntries.find(item => item.value === option.value);
        // });
        // setFilteredEntries(filteredOptions);

      } else { 
        const {name, value} = e.target
        if (name === "quantities") {
          var newItemList = items;
          var newEntries = newItemList.map((item, index) => {
            if (index === id) {
              item["quantities"] = value;
            }
            return item;
          });
          setItems(newEntries);
        } else if (name === "units"){
          var newItemList = items;
          var newEntries = newItemList.map((item, index) => {
            if (index === id) {
              item["unit_value"] = value;
              item["units"] = value.split("|")[0];
              item["item_unit_id"] = value.split("|")[1];
            }
            return item;
          });
          setItems(newEntries);
        }
      }
    } else {
      const {name, value} = e.target
      if (name === "quantities") {
        var newItemList = receiveItems;
        var newEntries = newItemList.map((item, index) => {
          if (index === id) {
            item["quantities"] = value;
          }
          return item;
        });
        setReceiveItems(newEntries);
      } else if (name === "units"){
        var newItemList = items;
        var newEntries = newItemList.map((item, index) => {
          if (index === id) {
            item["unit_value"] = value;
            item["units"] = value.split("|")[0];
            item["item_unit_id"] = value.split("|")[1];
          }
          return item;
        });
        setItems(newEntries);
      }
    }
  }

  // INVOICE REMOVAL HANDLER
  function handleRemoveItem(id) {
    const rowId = id;
    const newItemList = [...items];
    newItemList.splice(rowId, 1);
    setItems(newItemList);
  }

  const handleRemove = (selectedFile) => {
    var newlist = fileList.filter((file) => {
      return selectedFile.uid !== file.uid;
    });
    setFileList(newlist);
  };

  const handleBeforeUpload = (file) => {
    setFileList([...fileList, file]);
    return false;
  };

  const handlePreview = async (file) => {
    if (Object.prototype.toString.call(file) === '[object File]') {
      const blob = new Blob([file], { type: file.type });
      file.preview = URL.createObjectURL(blob);
    }
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewFile(file.preview);
    setPreview(true);
  };

  const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

  //  DISPLAY THE LIST OF ITEMS TABLE
  function renderTable() {
    return (
      <Table className="ps-table">
        <thead>
          <tr>
            <th>Item</th>
            <th>Quantity</th>
            <th>Unit</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => {
            return (
              <tr>
                <td className="select-cell">
                  <SearchBox
                    showSearch
                    value={item.item_id_value}
                    placeholder={"Search Item..."}
                    className="react-select-container w-15vw"
                    dropdownClassName="z-large antdesign-custom-dropdown"
                    style={antdesignSelectStyle}
                    defaultActiveFirstOption={false}
                    suffixIcon={null}
                    filterOption={false}
                    onSearch={handleSearchItem}
                    onChange={(e) => handleItemChange(e, index, "additional", "item_id")}
                    notFoundContent={null}
                    options={(itemOptions || []).map((d) => ({
                    value: d.value,
                    label: d.label,
                    }))}
                  />
                  {/* <Select
                    className="text-start react-select-container"
                    classNamePrefix="react-select"
                    placeholder="Select Item..."
                    options={filteredEntries}
                    value={item.entry}
                    onChange={(e) => handleItemChange(e, index, "additional")}
                  /> */}
                  <InputError
                    isValid={isError.listInfo}
                    message={"Item is required"}
                  />
                </td>
                <td>
                  <Col>
                    <Form.Control
                      type="number"
                      name="quantities"
                      value={item.quantities}
                      onChange={(e) => handleItemChange(e, index, "additional")}
                    />
                    <InputError
                      isValid={isError.listInfo}
                      message={"Quantity is required"}
                    />
                  </Col>
                </td>
                <td>
                  <Col>
                    {/* <Form.Control
                      type="text"
                      name="units"
                      value={item.units}
                      onChange={(e) => handleItemChange(e, index, "additional")}
                    /> */}
                    <Form.Select
                        name="units"
                        id={item.id}
                        value={item.unit_value}
                        onChange={(e) => handleItemChange(e, index, "additional")}
                    >
                        <option value="">Select</option>
                        {item.item_units?.map((data) => {
                            return (
                            <option value={data.unit_from + "|" + data.id}>
                                {data.unit_from}
                            </option>
                            );
                        })}
                    </Form.Select>
                  </Col>
                </td>
                <td>
                  <img
                    src={trash}
                    onClick={() => handleRemoveItem(index)}
                    className="cursor-pointer"
                    alt=""
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }

  function renderTableEdit() {
    return (
      <Table className="ps-table">
        <thead>
          <tr>
            <th>Item</th>
            <th>Unit</th>
            <th>Expected</th>
            <th>Received</th>
          </tr>
        </thead>
        <tbody>
          {receiveItems.map((item, index) => {
            return (
              <tr key={index}>
                <td className="franchise-td-gray">{item.label}</td>
                <td className="franchise-td-gray">{item.units}</td>
                <td className="franchise-td-gray">
                  {/* {isNaN(numberFormat(item.expected_qty))?"additional":numberFormat(item.expected_qty)} */}
                  {item.expected_qty}
                </td>
                <td className="franchise-td-gray">
                  <Col>
                    <Form.Control
                      type="text"
                      name="quantities"
                      defaultValue={item.quantities}
                      onChange={(e) => handleItemChange(e, index, "itemlist")}
                    />
                  </Col>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }

  const handleSearchItem = (newValue) => {
      if(newValue.length > 2) { //if length of the input is greater than 3, it will call the search api
      handleFetchItems(newValue, setItemOptions);
      }
  };


  // new api for searching items
  async function handleFetchItems(value, setItemOptions) {
    setItemOptions([]);
    const response = await getAllItemList(newTransfer.branch_from, value);
    if (response.data) {
      var itemsList = response.data.data.map((entry) => {
        var info = {};
        info.name = "item_id";
        info.value = entry.item_id;
        info.label = entry.item_name;
        info.entry = {
          name: "item_id",
          value: entry.item_id,
          label: entry.item_name,
        };
        info.unit = entry.unit_to_name;
        info.prices = entry.price;
        info.current_qty = parseInt(entry.current_qty);
        info.item_units = entry.item_units
        return info;
      });
      setItemOptions(itemsList);
    } else {
      response.error?.data?.messages?.map((data) => {
        return toast.error(data, {
          style: toastStyle(),
        });
      })
    }
  }
  //  FETCH INVENTORY ITEMS   //
  // async function fetchAllItems(id, shopType) {
  //   setEntries([]);
  //   setFilteredEntries([]);
  //   setShowLoader(true);

  //   if (edit || request) {
  //     const response = await getAllItemList(id);
  //     if (response.data) {
  //       var itemsList = response.data.data;
  //       var data = itemsList.map((entry) => {
  //         var info = {};
  //         info.name = "item_id";
  //         info.value = entry.item_id;
  //         info.label = entry.item_name;
  //         info.entry = {
  //           name: "item_id",
  //           value: entry.item_id,
  //           label: entry.item_name,
  //         };
  //         info.item_unit_id = entry.item_unit_id;
  //         info.unit = entry.unit_from_name;
  //         info.prices = entry.price;
  //         info.current_qty = parseInt(entry.current_qty);
  //         // entry.item_units
  //         //   ? entry.item_units.map((i) => {
  //         //       info.unit = i.unit_to_name;
  //         //       info.prices = i.price;
  //         //       info.current_qty = parseInt(i.current_qty);
  //         //     })
  //         //   : (info.units = "");
  //         return info;
  //       });
  //       setEntries(data);
  //       setFilteredEntries(data);
  //     }
  //   }
  //   setShowLoader(false);
  // }

  //API CALL
  async function fetchAllEmployees() {
    setShowLoader(true);
    const response = await getAllEmployees();
    if (response.data.data) {
      var employeesList = response.data.data;
      employeesList.map((employee) => {
        var info = {};

        info.name = "received_by";
        info.label = employee.first_name + " " + employee.last_name;
        info.value = employee.id;

        setEmployeeOptions((prev) => [...prev, info]);
      });
      response.data.data.map((data, key) => {
        employeesList[key].full_name = data.first_name + " " + data.last_name;
      });
    }
    setShowLoader(false);
  }

  /** POST API - SAVE NEW PAYMENT **/
  async function saveTransferReceive() {
    if (isClicked) {
      return;
    }
    if (validateTransferReceive(newTransfer, items, setIsError, "add")) {
      setIsClicked(true);
      newTransfer.attachments = fileList
      const response = await createTransferReceive(
        newTransfer,
        receiveItems,
        items
      );
      if (response.data) {
        toast.success(response.data.message, { style: toastStyle() });
        setTimeout(() => {
          navigate("/transfers");
        }, 1000);
      } else {
          setIsClicked(false);
          response.error?.response?.data?.messages.map((data) => {
              return toast.error(data);
          })
      }
    } else {
      toast.error("Please fill in all required fields", {
        style: toastStyle(),
      });
    }
  }

  /** POST API - SAVE NEW PAYMENT **/
  async function editTransferReceive() {
    if (validateTransferReceive(newTransfer, items, setIsError, "edit")) {
      newTransfer.attachments = fileList
      const response = await updateTransferReceive(
        newTransfer,
        receiveItems,
        items
      );

      if (response.data) {
        toast.success(response.data.message, { style: toastStyle() });
        setTimeout(() => {
          navigate(-1);
        }, 1000);
      } else {
          response.error?.response?.data?.messages.map((data) => {
              return toast.error(data);
          })
      }
    } else {
      toast.error("Please fill in all required fields", {
        style: toastStyle(),
      });
    }
  }

  async function handleApproveTransferReceive() {
    const response = await updateTransferReceiveStatus(newTransfer.id, "completed");

    if (response.data) {
      toast.success(response.data.message, {
        style: toastStyle(),
      });
      setTimeout(() => {
        handleCloseApproveModal();
        // refreshPage();
      }, 1000);
    } else {
        response.error?.response?.data?.messages.map((data) => {
            return toast.error(data);
        })
        setTimeout(() => {
          handleCloseApproveModal();
          // refreshPage();
        }, 1000);
    }
  }

  async function fetchTransfer() {
    if (type !== "update") {
      const response = await getTransfer(id);

      if (response.data) {
        var data = response.data.data[0];
        setNewTransfer({
          transfer_id: data.id,
          transfer_date: data.transfer_date,
          transfer_number: data.transfer_number,
          branch_to: data.branch_to,
          branch_to_name: data.branch_to_name,
          branch_from: data.branch_from,
          branch_from_name: data.branch_from_name,
          remarks: data.remarks,
          status: data.status,
          dispatcher: data.dispatcher,
          dispatcher_name: data.dispatcher_name,
          transfer_receive_date: Moment().format("YYYY-MM-DD"),
        });
        // setEmployeeValue({
        //     name: "received_by",
        //     label: data.dispatcher_name,
        //     value: data.dispatcher,
        // });
        var itemEntries = data.transfer_items;
        var clean = itemEntries.map((entry) => {
          var info = {};
          info.name = "item_id";
          info.id = entry.id;
          info.value = entry.item_id;
          info.label = entry.item_name;
          info.item_id = entry.item_id;
          info.item_id_value = {
            name: "item_id",
            value: entry.item_id,
            label: entry.item_name,
          };
          info.units = entry.unit;
          info.item_unit_id = entry.item_unit_id;
          info.prices = entry.price;
          info.expected_qty = numberFormat(entry.qty);
          info.quantities = numberFormat(entry.remaining_qty);
          return info;
        });
        setReceiveItems(clean);
        // fetchAllItems(data.branch_from, "");
      }
    } else {
      const response = await getTransferReceive(id);
      // const response = await searchTransferReceiveByTransferID(id);

      if (response.data) {
        var data = response.data.data[0];
        setNewTransfer({
          id: data.id,
          transfer_receive_id: data.id,
          transfer_id: data.transfer_id,
          transfer_date: data.transfer_date,
          transfer_number: data.transfer_number,
          branch_to: data.branch_to,
          branch_to_name: data.branch_to_name,
          branch_from: data.branch_from,
          branch_from_name: data.branch_from_name,
          remarks: data.remarks,
          status: data.status,
          dispatcher: data.dispatcher,
          dispatcher_name: data.dispatcher_name,
          transfer_receive_date: data.transfer_receive_date
            ? getTodayDateISOFormat(data.transfer_receive_date)
            : "",
          received_by: data.received_by,
        });
        setEmployeeValue({
          name: "received_by",
          label: data.received_by_name,
          value: data.received_by,
        });
        var itemEntries = data.transfer_receive_items;
        var clean = itemEntries.map((entry) => {
          var info = {};
          info.name = "item_id";
          info.id = entry.id;
          info.value = entry.item_id;
          info.label = entry.item_name;
          info.entry = {
            name: "item_id",
            value: entry.item_id,
            label: entry.item_name,
          };
          info.units = entry.unit;
          info.item_unit_id = entry.item_unit_id;
          info.prices = entry.price;
          info.expected_qty = entry.transfer_qty
            ? numberFormat(entry.transfer_qty)
            : "Additional";
          info.quantities = numberFormat(entry.qty);
          return info;
        });
        setReceiveItems(clean);
        // fetchAllItems(data.branch_from, "");
      }
    }
  }

  function handleSubmit() {
    if (edit && type === "create") {
      saveTransferReceive();
    } else if (edit && type === "update") {
      editTransferReceive();
    }
  }

  useEffect(() => {
    if (edit) {
      fetchAllEmployees();
      fetchTransfer();
    }
  }, []);

  // useEffect(() => {
  //   if (state) {
  //     fetchAllItems(state.from_branch_id);
  //     setNewTransfer((prev) => {
  //       return {
  //         ...prev,
  //         branch_from: state.from_branch_id,
  //         branch_to: state.to_branch_id,
  //       };
  //     });

  //     var requestedItems = state.purchased_items.map((item) => {
  //       var info = {};
  //       info.entry = {
  //         name: "item_id",
  //         value: item?.item_id,
  //         label: item?.item_name,
  //       };
  //       info.quantities = "0";
  //       info.units = item.unit_to_name;
  //       info.current_qty = item?.current_qty;

  //       return info;
  //     });
  //     setItems(requestedItems);
  //   }
  // }, []);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"TRANSFERS"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <div className="row">
          {type === "create" ? (
            <h1 className="page-title mb-4">RECEIVE TRANSFER </h1>
          ) : (
            <h1 className="page-title mb-4">REVIEW TRANSFER </h1>
          )}
        </div>

        {/* FORM */}

        <div className="edit-form ps-form">
          <Fragment>
            <Row className="pt-3 mb-2">
              <Col xs={3}>
                <span className="nc-modal-custom-row uppercase">
                  Transfer Receive Date
                  <label className="badge-required">{` *`}</label>
                </span>
              </Col>
              <Col xs={3}>
                <span className="nc-modal-custom-row uppercase">
                  transfer slip no.
                  <label className="badge-required">{` *`}</label>
                </span>
              </Col>
              <Col xs={3}>
                <span className="nc-modal-custom-row uppercase">
                  From
                  <label className="badge-required">{` *`}</label>
                </span>
              </Col>
              <Col xs={3}>
                <span className="nc-modal-custom-row uppercase">
                  To
                  <label className="badge-required">{` *`}</label>
                </span>
              </Col>
            </Row>
            <Row className="align-items-start">
              <Col xs={3}>
                <Form.Control
                  type="date"
                  name="transfer_receive_date"
                  defaultValue={newTransfer.transfer_receive_date}
                  className="react-select-container"
                  onChange={(e) => handlePayChange(e)}
                />
                <InputError
                  isValid={isError.transfer_receive_date}
                  message={"Transfer receive date is required"}
                />
              </Col>
              <Col xs={3}>
                <Form.Control
                  type="number"
                  name="transfer_number"
                  defaultValue={newTransfer.transfer_number}
                  className="react-select-container"
                  onChange={(e) => handlePayChange(e)}
                  disabled
                />
              </Col>
              <Col xs={3}>
                <Form.Control
                  type="text"
                  name="branch_from_name"
                  defaultValue={newTransfer.branch_from_name}
                  className="react-select-container"
                  disabled
                />
              </Col>
              <Col xs={3}>
                <Form.Control
                  type="text"
                  name="branch_to_name"
                  defaultValue={newTransfer.branch_to_name}
                  className="react-select-container"
                  disabled
                />
              </Col>
            </Row>
            <Row className="mt-4 mb-2">
              {edit && (
                <Col xs={6}>
                  <span className="nc-modal-custom-row uppercase">
                    Dispatcher
                  </span>
                </Col>
              )}

              <Col xs={6}>
                <span className="nc-modal-custom-row uppercase">
                  Received By
                  <label className="badge-required">{` *`}</label>
                </span>
              </Col>
            </Row>
            <Row>
              {edit && (
                <Col xs={6}>
                  <Form.Control
                    type="text"
                    name="dispatcher_name"
                    defaultValue={newTransfer.dispatcher_name}
                    className="react-select-container"
                    disabled
                  />
                </Col>
              )}
              {edit && (
                <Col xs={6}>
                  <Select
                    name="received_by"
                    className="react-select-container"
                    classNamePrefix="react-select"
                    placeholder="Select Employee..."
                    value={employeeValue}
                    options={employeeOptions}
                    onChange={(e) => handleSelectChange(e)}
                  />
                  <InputError
                    isValid={isError.received_by}
                    message={"Recieved by is required"}
                  />
                </Col>
              )}
            </Row>
          </Fragment>

          {/* INVOICES */}
          {/* <div className="mt-4 pt-3 d-flex flex-column">
            <span className="nc-modal-custom-row mb-2 uppercase">
              ITEM LIST <label className="badge-required">{` *`}</label>
            </span>
            <div className="edit-purchased-items">
              {receiveItems.length === 0 ? (
                <div className="entries-not-found">
                  {add && "You haven't added any items yet."}
                  {edit && "Items not found."}
                </div>
              ) : (
                <>
                  {edit && <>{renderTableEdit()}</>}
                  {!edit && <>{renderTable()}</>}
                </>
              )}
            </div>
          </div> */}
          <div className="mt-4 pt-3 d-flex flex-column">
            <span className="nc-modal-custom-row mb-2 uppercase">
              ITEM LIST <label className="badge-required">{` *`}</label>
            </span>
            <Container fluid className="edit-purchased-items">
              {receiveItems.length === 0 ? (
                <div className="entries-not-found">
                  {add && "You haven't added any items yet."}
                  {edit && "Items not found."}
                </div>
              ) : (
                <>
                  {edit && <>{renderTableEdit()}</>}
                  {!edit && <>{renderTable()}</>}
                </>
              )}
            </Container>
          </div>

          <div className="mt-4 pt-3 d-flex flex-column">
            <span className="nc-modal-custom-row mb-2 uppercase">
              ADDITIONAL RECEIVED{" "}
            </span>
            <Container fluid className="edit-purchased-items">
              {items.length === 0 ? (
                <div className="entries-not-found">
                  {"You haven't added any items yet."}
                </div>
              ) : (
                <>{renderTable()}</>
              )}
            </Container>
            <Row className="my-2 align-right pb-2 align-items-start">
              <Col className="pt-3 PO-add-item">
                <Button type="button" onClick={() => AddItem()}>
                  Add Item
                </Button>
              </Col>
            </Row>
          </div>
          <Row className="mt-2 mb-2">
            <Col>
              <span className="edit-label">File Attachment</span>
                <Dragger
                    {...{
                    // style: { width: 550 },
                    file,
                    defaultFileList: file,
                    onRemove: handleRemove,
                    beforeUpload: handleBeforeUpload,
                    multiple: false,
                    // onChange: handleOnChange,
                    listType: "picture",
                    progress: { showInfo: true },
                    }}
                >
                    <img
                        alt="upload"
                        src={upload}
                        className="cursor-pointer"
                    />
                    <p className="ant-upload-text">
                        Click or drag file to this area to upload
                    </p>
                </Dragger>
            </Col>
          </Row>

          <div className="d-flex justify-content-end pt-5 pb-3">
            <button
              type="button"
              className="button-secondary me-3"
              onClick={() => navigate("/transfers")}
            >
              Cancel
            </button>

            {isClicked ? (
              <div className="button-primary me-3 d-flex justify-content-center">
                <ReactLoading
                  type="bubbles"
                  color="#FFFFFF"
                  height={50}
                  width={50}
                />
              </div>
            ) : (
              <button
                type="button"
                className="button-primary me-3"
                onClick={handleSubmit}
              >
                {type === "create" ? "Create" : "Update"}
              </button>
            )}
          </div>
        </div>
      </div>
      <TransferModal
        show={showApproveModal}
        hide={handleCloseApproveModal}
        type="Approve transfer request"
        handler={handleApproveTransferReceive}
      />
      <Modal open={fileSizeExceeded} title={""} footer={null} onCancel={()=>setFileSizeExceeded(false)}>
        File size must not exceed 5MB.
      </Modal>
      <Footer/>
    </div>
  );
}

FormReceiveTransfer.defaultProps = {
  add: false,
  edit: false,
};

export default FormReceiveTransfer;
